import React, { useState } from 'react';
import { MarketplaceHeader } from '../components/layout/MarketplaceHeader';
import { Footer } from '../components/layout/Footer';
import { RestaurantCard } from '../components/marketplace/RestaurantCard';
import { useMarketplaceData, useRestaurants } from '../lib/hooks';
import { Skeleton } from '../components/ui/Skeleton';
import { EmptyState } from '../components/ui/EmptyState';
import { Store, Search, MapPin, Filter } from 'lucide-react';
export function RestaurantListingPage() {
  const {
    categories,
    zones,
    loading: marketplaceLoading
  } = useMarketplaceData();
  const [filters, setFilters] = useState({
    zoneId: '',
    categoryId: '',
    search: ''
  });
  const {
    restaurants,
    loading: restaurantsLoading
  } = useRestaurants(filters);
  const handleFilterChange = (key: keyof typeof filters, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };
  return <div className="min-h-screen flex flex-col bg-brand-offwhite" data-id="element-2622">
      <MarketplaceHeader data-id="element-2623" />

      <main className="flex-1" data-id="element-2624">
        <div className="bg-white border-b border-gray-100 py-8" data-id="element-2625">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2626">
            <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-2627">
              Explorar Restaurantes
            </h1>

            {/* Filters Bar */}
            <div className="flex flex-col md:flex-row gap-4" data-id="element-2628">
              {/* Search */}
              <div className="flex-1 relative" data-id="element-2629">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2630" />
                <input type="text" placeholder="Buscar restaurante..." value={filters.search} onChange={e => handleFilterChange('search', e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-brand-amber transition-shadow" data-id="element-2631" />
              </div>

              {/* Zone Filter */}
              <div className="w-full md:w-64 relative" data-id="element-2632">
                <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2633" />
                <select value={filters.zoneId} onChange={e => handleFilterChange('zoneId', e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-brand-amber appearance-none bg-white cursor-pointer" data-id="element-2634">
                  <option value="" data-id="element-2635">Todas las zonas</option>
                  {zones.map(zone => <option key={zone.id} value={zone.id} data-id="element-2636">
                      {zone.name}
                    </option>)}
                </select>
              </div>

              {/* Category Filter */}
              <div className="w-full md:w-64 relative" data-id="element-2637">
                <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2638" />
                <select value={filters.categoryId} onChange={e => handleFilterChange('categoryId', e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-brand-amber appearance-none bg-white cursor-pointer" data-id="element-2639">
                  <option value="" data-id="element-2640">Todas las categorías</option>
                  {categories.map(category => <option key={category.id} value={category.id} data-id="element-2641">
                      {category.name}
                    </option>)}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-2642">
          {restaurantsLoading || marketplaceLoading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2643">
              {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} variant="card" className="h-[320px]" data-id="element-2644" />)}
            </div> : restaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2645">
              {restaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-2646" />)}
            </div> : <div className="py-12" data-id="element-2647">
              <EmptyState icon={Store} title="No se encontraron restaurantes" description="Intenta ajustar tus filtros de búsqueda para ver más resultados." actionLabel="Limpiar filtros" onAction={() => setFilters({
            zoneId: '',
            categoryId: '',
            search: ''
          })} data-id="element-2648" />
            </div>}
        </div>
      </main>

      <Footer data-id="element-2649" />
    </div>;
}